<template>
    <div class="product-list" v-if="ready">

        <span class="product-list-loader" v-loading="initalListLoading" :class="{'hide': !initalListLoading, 'center': sidebarToogle}"></span>

        <div class="product-list-title" v-if="!initalListLoading">
          <div class="product-list-title-left">
            <template v-if="$store.state.assetQuery && $store.state.assetQuery.search !== '' && $store.state.assetQuery.search">
              <div class="product-list-title-clear"  @click.prevent="clearSearch()">
                <div class="product-list-title-clear icon"></div>clear
              </div>
              <div class="product-list-title-results-desktop">
                {{this.total}} results for '{{$store.state.assetQuery.search.replace(/\"/g,'')}}':
              </div>
              <div class="product-list-title-results-mobile">
                {{this.total}} results
              </div>
            </template>
            <template v-else>
              {{numberWithCommas(this.total)}} items
            </template>
          </div>
          <div class="product-list-title-right">
            View
            <div class="product-list-title-view-switch-desktop">
              <a @click.prevent="setGridView('desktop', 2)" href="#" :class="{'active': $store.state.view.desktop === 2}">2</a>
              <a @click.prevent="setGridView('desktop', 3)" href="#" :class="{'active': $store.state.view.desktop === 3}">3</a>
              <a @click.prevent="setGridView('desktop', 4)" href="#" :class="{'active': $store.state.view.desktop === 4}">4</a>
            </div>
            <div class="product-list-title-view-switch-mobile">
              <a @click.prevent="setGridView('mobile', 1)" href="#" :class="{'active': $store.state.view.mobile === 1}">1</a>
              <a @click.prevent="setGridView('mobile', 2)" href="#" :class="{'active': $store.state.view.mobile === 2}">2</a>
            </div>
          </div>
        </div>

        <div class="product-list-inner" :class="'desktop-view-' + $store.state.view.desktop + ' mobile-view-' + $store.state.view.mobile">

            <div class="product-list-item"
                 :class="{'selected': isInSelects(item)}"
                 v-for="item in products"
                 :key="item.id">
                <div class="product-list-item-inner">

                    <div @click.prevent="toggleSelects(item)" class="product-list-item-link">
                      <img :src="getbase64EncodedImage(item.attributes)" />
                      <div v-if="isInSelects(item)" class="product-list-item-selected"></div>
                      <div @click.stop="productClickAction(item)" class="product-list-item-more"></div>
                    </div>
                </div>
            </div>

            <div v-if="scrollLoading" v-loading="scrollLoading" class="product-list-scroll-loader helper"></div>
        </div>
    </div>
</template>

<script>
import { HTTP } from '@/services/api'
import { EventBus } from '@/services/eventbus'

import axios from 'axios'
export default {
  name: 'ProductList',
  metaInfo () {
    return {
      title: 'Products'
    }
  },
  data () {
    return {
      productSelect: {
        clickCount: 0,
        clickTimer: null,
        clickDelay: 300
      },
      token: null,
      listOpened: false,
      initalListLoading: true,
      scrollLoading: false,
      ready: true,
      tableData: [],
      sidebarToogle: false,
      products: [],
      total: 0,
      windowWidth: 0,
      mainLoaderBackToTop: false
    }
  },
  watch: {
    '$store.state.assetQuery': {
      handler () {
        this.loadData()
      },
      deep: false
    }
  },
  created () {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  mounted () {
    EventBus.$on('sidebar-toggle', (payload) => (this.sidebarToogle = payload))
    EventBus.$on('asset-query', () => this.loadData())
    EventBus.$on('list-loader', () => (this.mainLoaderBackToTop = true))
    EventBus.$on('list-loader', (payload) => (this.initalListLoading = payload))
    EventBus.$on('list-scroll-loader', (payload) => (this.scrollLoading = payload))
    this.scroll()
    if (this.$route.params.search) {
      this.$store.dispatch('setAssetQuery', {
        search: this.$route.params.search
      })
      EventBus.$emit('search', true)
    } else {
      this.loadData()
    }
  },
  activated () {
    EventBus.$on('asset-query', () => this.loadData())
    if (this.$route.params.search) {
      this.$store.dispatch('setAssetQuery', {
        search: this.$route.params.search
      })
      EventBus.$emit('search', true)
    }
  },
  beforeDestroy () {
    EventBus.$off('list-loader')
    EventBus.$off('set-product-details')
    EventBus.$off('asset-query')
    window.removeEventListener('resize', this.handleResize)
  },
  deactivated () {
    EventBus.$off('asset-query')
  },
  methods: {
    getbase64EncodedImage (item) {
      if (typeof item['com.extensis.portfolio.Preview'] !== 'undefined') {
        return 'data:image/jpeg;base64,' + item['com.extensis.portfolio.Preview'][0].replace(/(\r\n|\n|\r)/gm, '')
      } else if (typeof item['Thumbnail'] !== 'undefined') {
        return 'data:image/jpeg;base64,' + item['Thumbnail'][0].replace(/(\r\n|\n|\r)/gm, '')
      }
    },
    numberWithCommas (x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    loadData () {
      if (this.$store.state.assetQuery.path === '' || typeof this.$store.state.rootPath === 'undefined' || this.$store.state.rootPath === '') {
        this.initalListLoading = false
        return
      }

      if (!this.mainLoaderBackToTop) {
        if (!this.scrollLoading) {
          this.initalListLoading = true
        }
      } else {
        this.initalListLoading = true
      }

      if (this.token) {
        this.token.cancel()
      }
      this.token = CancelToken.source()

      HTTP({
        method: 'GET',
        url: '/api/v1/assets',
        crossdomain: true,
        params: this.$store.state.assetQuery,
        cancelToken: this.token.token
      }).then(response => {
        if (this.$store.state.assetQuery.pagination.startingIndex !== 0) {
          this.products.push(...response.data.data.assets)
        } else {
          this.products = []
          this.products = response.data.data.assets
          this.total = response.data.data.totalNumberOfAssets
        }
        this.ready = true
        this.scrollLoading = false
        this.initalListLoading = false
        this.mainLoaderBackToTop = false
      }).catch((error) => {
        this.products = []
        this.total = 0
        if (!axios.isCancel(error)) {
          this.initalListLoading = false
          this.mainLoaderBackToTop = false
        }
      })
    },
    scroll () {
      window.onscroll = () => {
        let bottomOfWindow = (Math.ceil(Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop) + window.innerHeight) + 3) > Math.ceil(document.documentElement.offsetHeight)
        if (bottomOfWindow && !this.scrollLoading && !this.initalListLoading && this.total > this.products.length) {
          this.scrollLoading = true
          this.$store.dispatch('setAssetQuery', {
            pagination: {
              size: process.env.VUE_APP_API_PAGINATION_SIZE,
              startingIndex: parseInt(this.$store.state.assetQuery.pagination.startingIndex) + parseInt(process.env.VUE_APP_API_PAGINATION_SIZE)
            }
          })
        }
      }
    },
    addToCart (product) {
      this.$store.dispatch('addRequestItem', product)
      this.$notify({
        message: 'Added to selects',
        type: 'success',
        position: 'bottom-right',
        duration: 1750
      })
    },
    removeFromCart (item) {
      this.$store.dispatch('removeRequestItem', {
        item: item,
        all: false
      })
      this.$notify({
        message: 'Removed from selects',
        type: 'success',
        position: 'bottom-right',
        duration: 1750
      })
    },
    productClickAction (item) {
      let routeData = this.$router.resolve('/products/' + item.id)
      window.open(routeData.href, '_blank')
    },
    isInSelects (item) {
      return this.$store.state.request.findIndex(function (req) {
        return parseInt(req.id) === parseInt(item.id)
      }) !== -1
    },
    toggleSelects (item) {
      if (this.isInSelects(item)) {
        this.removeFromCart(item)
      } else {
        this.addToCart(item)
      }
    },
    handleResize () {
      this.windowWidth = window.innerWidth
    },
    setGridView (type, value) {
      this.$store.dispatch('setGridView', {
        desktop: type === 'desktop' ? value : this.$store.state.view.desktop,
        mobile: type === 'mobile' ? value : this.$store.state.view.mobile
      })
    },
    clearSearch () {
      this.$store.dispatch('setAssetQuery', {
        search: ''
      })
      EventBus.$emit('search', true)
    }
  }
}

const CancelToken = axios.CancelToken
</script>
